
import { useAxios } from "../utils/hooks";

export const LeaveService = () => {

    const AxiosInstance = useAxios();
    const saveHierarchy = async (designation: string, steps: { stepNumber: number, approvers: string[] }[]) => {

        try {
            const res: any = await AxiosInstance.current?.post(`/route/leave-approval-hierarchies`, { designation, steps });
            return res;
        } catch (error) {
            console.error(error);
        }
    }
    const fetchAllHierarchies = async () => {

        try {
            const res: any = await AxiosInstance.current?.get(`/route/leave-approval-hierarchies/get-all-hierarchies`);
            return res;
        } catch (error) {
            console.error(error);
        }
    }

    const fetchHierarchyByDesignation = async (designation: string) => {

        try {
            const res: any = await AxiosInstance.current?.get(`/route/leave-approval-hierarchies/get-hierarchy-by-designation?designation=${encodeURIComponent(designation)}`);
            return res;
        } catch (error) {
            console.error(error);
        }
    }
    const deleteHierarchy = async (designation: string) => {
        try {
            const res = await AxiosInstance.current?.delete(`/route/leave-approval-hierarchies/${encodeURIComponent(designation)}`);
            return res?.data?.data; // return the URL directly
        } catch (error) {
            console.error("Error fetching appointment form:", error);
            return null;
        }
    };

    const getStepHierarchyByDesignation = async () => {

        try {
            const res: any = await AxiosInstance.current?.get(`/route/leave-approval-hierarchies/getStepHierarchyByDesignation`);
            return res;
        } catch (error) {
            console.error(error);
        }
    }

    // Fetch pending approvals for the current user
    const getPendingApprovals = async () => {
        try {
            const res: any = await AxiosInstance.current?.get(`/route/leave-approval-hierarchies/pending-approvals`);
            return res;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    // Fetch leave history for the current user
    const getLeaveHistory = async () => {
        try {
            const res: any = await AxiosInstance.current?.get(`/route/leave-approval-hierarchies/leave-history`);
            return res;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    // Update approval history status (approve/reject/pending)
    const updateApprovalHistoryStatus = async (approvalHistoryId: number, status: string, remarks?: string) => {
        try {
            const res: any = await AxiosInstance.current?.post(`/route/leave-approval-hierarchies/update-approval-history-status`, {
                approvalHistoryId,
                status,
                remarks
            });
            return res;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    // Assign substitute to a leave
    const updateApplyLeaveSubstitute = async (applyLeaveId: number, substituteUserId: number) => {
        try {
            const res: any = await AxiosInstance.current?.post(`/route/leave-approval-hierarchies/update-applyleave-substitute`, {
                applyLeaveId,
                substituteUserId
            });
            return res;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    // Get next step approvers for a leave
    const getNextStepApproversForLeave = async (applyLeaveId: number) => {
        try {
            const res: any = await AxiosInstance.current?.get(`/route/users/getNextStepApproversForLeave?applyLeaveId=${applyLeaveId}`);
            return res;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    // Create leave approval history (forward leave)
    const createLeaveApprovalHistory = async (applyLeaveId: number, stepNumber: number, approverId: number) => {
        try {
            const res: any = await AxiosInstance.current?.post(`/route/users/createLeaveApprovalHistory`, {
                applyLeaveId,
                stepNumber,
                approverId
            });
            return res;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    const getMedicalLeave = async () => {
        try {
            const res: any = await AxiosInstance.current?.get(`/route/leave-approval-hierarchies/getMedicalLeave`);
            return res;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    const uploadMedicalDoc = async (data: any) => {
        try {
            const res: any = await AxiosInstance.current?.post(`/route/leave-approval-hierarchies/uploadMedicalDoc`, data);
            return res;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    const getLeaveBalanceList = async () => {
        try {
            const res: any = await AxiosInstance.current?.get(
                `/route/leave-approval-hierarchies`
            );
            return res;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    // ✅ Download Excel from Backend
    const getLeaveBalanceExcelFormat = async () => {
        try {
            const res: any = await AxiosInstance.current?.get(
                `/route/leave-approval-hierarchies/export`,
                {
                    responseType: "blob", // VERY IMPORTANT
                }
            );
            return res;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    const uploadLeaveBalanceExcel = async (data: FormData) => {
        try {
            const res: any = await AxiosInstance.current?.post(
                `/route/leave-approval-hierarchies/upload`,
                data,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            return res;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    return {
        saveHierarchy, fetchAllHierarchies, fetchHierarchyByDesignation, deleteHierarchy, getStepHierarchyByDesignation,
        getPendingApprovals, getLeaveHistory, updateApprovalHistoryStatus, updateApplyLeaveSubstitute, getNextStepApproversForLeave,
        createLeaveApprovalHistory, getMedicalLeave, uploadMedicalDoc, getLeaveBalanceList, getLeaveBalanceExcelFormat, uploadLeaveBalanceExcel
    }
}